import React from "react";
import MaterialTable from "material-table";
import Box from "@material-ui/core/Box";
import PropTypes from "prop-types";

import { forwardRef } from 'react';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Clear from '@material-ui/icons/Clear';
import FilterList from '@material-ui/icons/FilterList';
import Remove from '@material-ui/icons/Remove';
import Search from '@material-ui/icons/Search';

const tableIcons = {
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />)
};

const DataTable = ({columns, data, title, useFiltering=false}) => {
  return(
    <Box mb={10} style={{ maxWidth: '100%' }}>
        <MaterialTable
          icons={tableIcons}
          columns={columns}
          data={data}
          title={title}
          options={{
            filtering: useFiltering,
            paging: false
          }}
        />
    </Box>
  )
};

DataTable.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  useFiltering: PropTypes.bool
};

export default DataTable